import { currentMonth } from 'src/utils/currentMonth';
import { Entry } from '../Entry';

const today = new Date();

export const offlineEntriesLastMonth: Entry[] = [
  {
    id: 'uuid-16308',
    memo: 'Bread and milk',
    tagIds: ['uuid-2', 'uuid-6', 'wasd-123'],
    amount: -4.17,
    date: currentMonth(2, -1, today),
  },
  {
    id: 'uuid-74474',
    memo: 'Mortgage',
    tagIds: ['uuid-18', 'uuid-6'],
    amount: -305.56,
    date: currentMonth(8, -1, today),
  },
  {
    id: 'uuid-36127',
    memo: 'Weekend shopping',
    tagIds: ['uuid-2', 'uuid-7'],
    amount: -4.17,
    date: currentMonth(17, -1, today),
  },
  {
    id: 'uuid-36127123',
    memo: 'Groceries shopping',
    tagIds: ['uuid-2', 'uuid-8'],
    amount: -34.72,
    date: currentMonth(9, -1, today),
  },
  {
    id: 'uuid-361271234123',
    memo: 'Groceries for dad',
    tagIds: ['uuid-2', 'uuid-8', 'uuid-19'],
    amount: -34.72,
    date: currentMonth(25, -1, today),
  },
  {
    id: 'uuid-74475',
    memo: 'Heating',
    tagIds: ['uuid-3', 'uuid-7'],
    amount: -4.17,
    date: currentMonth(5, -1, today),
  },
  {
    id: 'uuid-91735',
    memo: 'Electricity',
    tagIds: ['uuid-3', 'uuid-7'],
    amount: -16.67,
    date: currentMonth(5, -1, today),
  },
  {
    id: 'uuid-83483',
    memo: 'Avengers: Endgame',
    tagIds: ['uuid-10', 'uuid-7'],
    amount: -16.67,
    date: currentMonth(9, -1, today),
  },
  {
    id: 'uuid-834832211112',
    memo: 'Monday improv (second)',
    tagIds: ['uuid-10', 'uuid-7', 'uuid-19'],
    amount: -41.67,
    date: currentMonth(24, -1, today),
  },
  {
    id: 'uuid-834832211112',
    memo: 'Gokarting',
    tagIds: ['uuid-10', 'uuid-7', 'uuid-19'],
    amount: -41.67,
    date: currentMonth(24, -1, today),
  },
  {
    id: 'uuid-8348312322',
    memo: 'Monday improv',
    tagIds: ['uuid-10', 'uuid-8'],
    amount: -41.67,
    date: currentMonth(12, -1, today),
  },
  {
    id: 'uuid-834831232212312',
    memo: 'Laser Tag',
    tagIds: ['uuid-10', 'uuid-6'],
    amount: -26.39,
    date: currentMonth(15, -1, today),
  },
  {
    id: 'uuid-8348311123421',
    memo: 'August',
    tagIds: ['uuid-7'],
    amount: 2277.78,
    date: currentMonth(5, -1, today),
  },
  {
    id: 'uuid-83483111234212',
    memo: 'Revolut top up from bank account',
    tagIds: ['uuid-7', 'uuid-20', 'uuid-9'],
    amount: -694.44,
    date: currentMonth(6, -1, today),
  },
  {
    id: 'uuid-67355',
    memo: 'Gas (full tank)',
    tagIds: ['uuid-11', 'uuid-7'],
    amount: -54.17,
    date: currentMonth(8, -1, today),
  },

  {
    id: 'uuid-6735512312311299',
    memo: 'Train tickets',
    tagIds: ['uuid-11', 'uuid-8'],
    amount: -2.08,
    date: currentMonth(12, -1, today),
  },

  {
    id: 'uuid-55109',
    memo: 'Netflix',
    tagIds: ['uuid-4', 'uuid-7', 'uuid-10'],
    amount: -10.56,
    date: currentMonth(2, -1, today),
  },
  {
    id: 'uuid-551098',
    memo: 'Disney plus',
    tagIds: ['uuid-4', 'uuid-6', 'uuid-10'],
    amount: -8.89,
    date: currentMonth(2, -1, today),
  },
  {
    id: 'uuid-551091',
    memo: 'Spotify for mom',
    tagIds: ['uuid-4', 'uuid-6', 'uuid-19', 'uuid-10'],
    amount: -9.17,
    date: currentMonth(12, -1, today),
  },

  {
    id: 'uuid-95292',
    memo: "McDonald's",
    tagIds: ['uuid-7', 'uuid-5'],
    amount: -18.75,
    date: currentMonth(28, -1, today),
  },
  {
    id: 'uuid-952923',
    memo: 'KFC',
    tagIds: ['uuid-6', 'uuid-5'],
    amount: -20.42,
    date: currentMonth(2, -1, today),
  },
  {
    id: 'uuid-952924',
    memo: 'Blu Agori Gyros',
    tagIds: ['uuid-6', 'uuid-5'],
    amount: -6.53,
    date: currentMonth(2, -1, today),
  },
  {
    id: 'uuid-952924',
    memo: 'Blu Agori Gyros (again...)',
    tagIds: ['uuid-6', 'uuid-5'],
    amount: -6.53,
    date: currentMonth(23, -1, today),
  },
  {
    id: 'uuid-95292412312',
    memo: 'Revolut-top up from bank account',
    tagIds: ['uuid-6', 'uuid-20', 'uuid-9'],
    amount: 694.44,
    date: currentMonth(6, -1, today),
  },
  {
    id: 'uuid-95292412312111288876',
    memo: 'Cash withdrawal from bank account',
    tagIds: ['uuid-8', 'uuid-20', 'uuid-9'],
    amount: 222.22,
    date: currentMonth(7, -1, today),
  },
  {
    id: 'uuid-9529241231233432',
    memo: 'Cash withdrawal from bank account',
    tagIds: ['uuid-7', 'uuid-20', 'uuid-9'],
    amount: -222.22,
    date: currentMonth(7, -1, today),
  },
];
